<div class="cm-variations-container">
    <div class="cm-render-actions">
        <cm-button class="cm-render" [disabled]="$renderAllDisabled()" [class.cm-disabled]="$renderAllDisabled()" (click)="renderAll()">
            <ng-container cm-left-icon>
                <i class="fa-solid fa-image"></i>
            </ng-container>
            <ng-container cm-text> Render All</ng-container>
        </cm-button>
        <cm-button class="cm-render" [disabled]="$downloadAllDisabled()" [class.cm-disabled]="$downloadAllDisabled()" [matMenuTriggerFor]="downloadAllMenu">
            <ng-container cm-left-icon>
                <i class="fa-solid fa-save"></i>
            </ng-container>
            <ng-container cm-text> Download All</ng-container>
            <mat-menu #downloadAllMenu>
                <ng-template matMenuContent>
                    <button mat-menu-item (click)="downloadAll('image/png')">PNG</button>
                    <button mat-menu-item (click)="downloadAll('image/jpeg')">JPEG</button>
                    <button mat-menu-item (click)="downloadAll('image/tiff')">TIFF</button>
                    <button mat-menu-item (click)="downloadAll('image/x-exr')">EXR (Raw)</button>
                </ng-template>
            </mat-menu>
        </cm-button>
        <cm-button class="cm-delete-button" [disabled]="$deleteAllDisabled()" [class.cm-disabled]="$deleteAllDisabled()" (click)="deleteAll()">
            <ng-container cm-left-icon>
                <i class="far fa-trash"></i>
            </ng-container>
        </cm-button>
    </div>

    @if ($state() === "loading") {
        <div class="cm-progress-bar">
            <mat-progress-bar [mode]="$progress() === 0 ? 'indeterminate' : 'determinate'" [value]="$progress()"></mat-progress-bar>
            <button class="cm-cancel-btn" (click)="cancelCurrentOperation()" matTooltip="Cancel current operation">
                <i class="fa-solid fa-times"></i>
            </button>
        </div>
    }

    <div class="cm-render-stats">{{ $numRendering() }} Rendering / {{ $numRendered() }} Rendered / {{ $numFailed() }} Failed</div>

    @if ($allVariations(); as allVariations) {
        <div class="cm-filler"></div>
        <div class="cm-job-list-title">Variations ({{ allVariations.length }})</div>
        <div class="cm-variation-list">
            @if (allVariations.length === 0 && $state() === "loading") {
                <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
            } @else {
                @for (variation of allVariations; track variation.hash) {
                    <cm-list-item
                        [selected]="variation.hash === $currentLocalConfigurationHash() && $selectedUnassignedJob() === undefined"
                        [matTooltip]="variation.name"
                        (click)="setConfiguration(variation)"
                    >
                        <ng-container cm-title>
                            {{ variation.name }}
                        </ng-container>
                    </cm-list-item>
                    <div class="cm-variation-list-icons">
                        @if (variation.render; as render) {
                            <cm-template-job-icon [job]="render"></cm-template-job-icon>
                        }
                    </div>
                }
            }
        </div>
    }
    @if ($unassignedJobs(); as unassignedJobs) {
        @if (unassignedJobs.length > 0) {
            <div class="cm-filler"></div>
            <div class="cm-job-list-title">Unassigned Renders ({{ unassignedJobs.length }})</div>
            <div class="cm-unassigned-job-list">
                @for (unassignedJob of unassignedJobs; track unassignedJob.job.id) {
                    <cm-list-item
                        [selected]="unassignedJob.job.id === $selectedUnassignedJob()?.job?.id"
                        [matTooltip]="unassignedJob.displayName"
                        (click)="selectUnassignedJob(unassignedJob)"
                    >
                        <ng-container cm-title>
                            {{ unassignedJob.displayName }}
                        </ng-container>
                    </cm-list-item>
                    <div class="cm-unassigned-job-list-icons">
                        <cm-template-job-icon [job]="unassignedJob.job"></cm-template-job-icon>
                    </div>
                }
            </div>
        }
    }
</div>
